const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-heading text-2xl font-semibold tracking-[0.04em] flex items-center gap-2.5">
              <span className="inline-block w-2 h-2 bg-[#c88a53]" />
              MONOWOOD
            </div>
            <p className="mt-5 text-sm text-white/55 max-w-sm leading-relaxed">
              <span className="text-white/80">Sustainable. Solid. Simple.</span>
              <br />
              Monolithisches Vollholzsystem für die nächste Generation
              klimapositiver Architektur.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[0.7rem] uppercase tracking-[0.25em] text-white/40 font-semibold">
              Navigation
            </div>
            <ul className="mt-5 space-y-2.5">
              {[
                { href: "#vision", label: "Vision" },
                { href: "#technologie", label: "Technologie" },
                { href: "#investment", label: "Marktpotenzial" },
                { href: "#kontakt", label: "Partner werden" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="text-sm text-white/65 hover:text-[#c88a53] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[0.7rem] uppercase tracking-[0.25em] text-white/40 font-semibold">
              Kontakt
            </div>
            <ul className="mt-5 space-y-2.5 text-sm text-white/65">
              <li>MONOWOOD</li>
              <li>
                <a
                  href="mailto:info@monowood.ch"
                  data-testid="footer-email"
                  className="hover:text-[#c88a53] transition-colors"
                >
                  info@monowood.ch
                </a>
              </li>
              <li className="text-xs pt-3 flex gap-3 text-white/30">
                <a
                  href="/impressum"
                  data-testid="footer-impressum"
                  className="hover:text-white/60 transition-colors"
                >
                  Impressum
                </a>
                <span className="text-white/15">·</span>
                <a
                  href="/datenschutz"
                  data-testid="footer-datenschutz"
                  className="hover:text-white/60 transition-colors"
                >
                  Datenschutz
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/5 flex flex-col sm:flex-row gap-3 justify-between items-start sm:items-center">
          <div className="text-xs text-white/40 font-mono-num tracking-wider">
            © {new Date().getFullYear()} MONOWOOD — Alle Rechte vorbehalten.
          </div>
          <div className="text-[0.65rem] tracking-[0.3em] uppercase text-white/30">
            v 1.1
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
